export default __webpack_public_path__ + "static/media/arjun.a9c24644.jpg";